module.exports = __webpack_public_path__ + "979c9187f2dabe9d032754159414c6f7.png";